import React, {Component} from 'react'
import i18next from 'i18next';

import styled from '@emotion/styled'
import sv from '../../styles/styles'

import MediaListItem from './MediaListItem'
import {sourceActions} from "../../_actions";
import {connect} from "react-redux";

import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import {Hidden} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import MenuSharp from '@material-ui/icons/MenuSharp'
import CloseSharp from '@material-ui/icons/CloseSharp'
import {sourceConstants} from "../../_constants";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SyncIcon from '@material-ui/icons/Sync';
import {portfolioActionTypes} from "../../_constants/actions/analytics/portfolioActionTypes";

// STYLE ##########################################################

const DrawerButton = styled(Fab)`
    position: fixed!important;
    bottom: 120px;
    right: 20px;
    z-index: 1600;
`;

const HiddenContainer = styled(Hidden)`
    height: 100%;
`;

const Container = styled(Drawer)`
  flex: 1;
  height: 100%;
  position: relative;
  overflow-y: hidden;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  width: 360px;
  & .MuiDrawer-paper {
    height: 100%;
    position: unset;
  }
  & .MuiPaper-elevation1 {
    box-shadow: unset !important;
  }
`;

const MediaSection = styled(Accordion)`
  margin: 0px 0 !important;
  padding: 5px;
  
  & .MuiAccordionDetails-root {
    flex-direction: column;
    display: flex;
    -moz-box-align: start;
    align-items: start;
  }
  & .MuiAccordion-root.Mui-expanded {
    margin: 0px 0 !important;
    min-height: 36px !important;
  }
  & .MuiAccordion-root {
    min-height: 36px !important;
    padding: 0 16px 0 16px !important;
  }
  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 0px;
  }
  & .MuiAccordionSummary-root.Mui-expanded {
    min-height: 36px !important;
  }
  & .MuiAccordion-rounded:last-child {
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }
  & .MuiAccordionSummary-root {
    background: ${sv.colors.subtleGrey};
    box-shadow: 0px 2px 2px rgb(0,0,0,0.05);
    border-radius: 5px;
    color: black;
    font-weight: bold;
  }
  & .MuiAccordionSummary-expandIcon {
    color: black;
  }
  & .selectedItem {
    background: ${sv.colors.hover};
  }
`;

const SwipeableContainer = styled(SwipeableDrawer)`
  flex: 1;
  height: 100%;
  position: relative;
  overflow-y: hidden;
  width: 95%;
  max-width: 360px;
  & .MuiDrawer-paper {
    height: 100%;
    position: unset;
  }
  & .MuiPaper-elevation1 {
    box-shadow: unset !important;
  }
`;

const SectionTitle = styled(AccordionSummary)`
  padding: 8px 24px;
  margin-top: 24px;
  color: ${sv.colors.grey};
  ${sv.label};
  & .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const RefreshButton = styled(`div`)`
  padding: 2px;
  &:hover {
    background-color: ${sv.colors.darkGray};
  }
`;

// COMPONENT ##########################################################
class MediaList extends Component {
  constructor(props) {
    super(props);
    this.focusScrollbar = this.focusScrollbar.bind(this);
    this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleSectionToggle = this.handleSectionToggle.bind(this);
  }

  state = {
    mobileOpen: false,
    active: true,
    inactive: true,
    pending: true,
    selectedList: null
  };

  handleDrawerToggle(goBack = true) {
    if (!this.state.mobileOpen) {
      history.pushState(null, 'drawerOpened');
      this.setState({ mobileOpen: true});
    } else {
      if (goBack) {
        this.setState({ mobileOpen: false}, () => (history.back()));
      } else {
        this.setState({ mobileOpen: false});
      }
    }
  };

  handleSectionToggle = (panel, listId) => (e, expanded) => {
	  const willExpand = !this.state[panel];  // if current expansion = false, then willExpand = true

	  // analytics-events
	  if(willExpand)  {  this.props.mediaListExpand(panel);  }
	  else            {  this.props.mediaListCollapse(panel);  }

    this.setState(state => ({
      [panel]: !state[panel],
      selectedList: listId
    }));
  };

  getFabIcon() {
    if (this.state.mobileOpen) {
      return <CloseSharp />;
    } else {
      return <MenuSharp />;
    }
  };

  focusScrollbar() {
    //Set focus so scrollbar works. We need small delay otherwise doesn't work.
    setTimeout(() => {
      if (this.container) {
        this.container.focus();
      }
    }, 10);
  }

  onBackButtonEvent(event) {
    if (this.state && this.state.mobileOpen) {
      this.handleDrawerToggle(false);
    }
  }

  handleResize(event) {
    //Close the drawer if resized and window becomes too big
    if (window.innerWidth > 960 && this.state.mobileOpen) {
      this.handleDrawerToggle(false);
    }
  }

  componentDidMount() {
    this.focusScrollbar();
    document.addEventListener('mousedown', this.focusScrollbar, false);
    window.addEventListener('popstate', this.onBackButtonEvent,false);
    window.addEventListener("resize", this.handleResize, false);

    const { currentSource }  = this.props;
    const { selectedItem } = currentSource;
    this.setState({ selectedList: selectedItem.status});

    //MediaSections don't expand when moving items between them when the state is initially set to false
    //we need to set to true and then set to false here if the selected item is not in there.
    const {sources} = this.props;
    const items = sources.list;
    const deactivatedItems = items.filter(i => i.status === sourceConstants.SOURCE_STATE.DEACTIVATED);
    this.setState({ inactive: deactivatedItems.some(v => v.id === selectedItem.id)});
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.focusScrollbar, false);
    window.removeEventListener("popstate", this.onBackButtonEvent, false);
    window.removeEventListener("resize", this.handleResize, false);
  }
  
  handleRefresh = () => {
    this.props.getSources();
  }

  handleSelectItem = (item) => {
    this.props.selectItem(item);
    this.setState({ selectedList: item.status});
    this.handleDrawerToggle();
  };

  handleItemChange(selectedItem, itemsList, name) {
    if (this.state.selectedList !== selectedItem.status && itemsList.some(v => v.id === selectedItem.id)) {
      this.setState(state => ({
        [name]: true,
        selectedList: selectedItem.status
      }));
    }
  }

  render() {
    const t = i18next.t;

    const {sources} = this.props;
    const items = sources.list;

    const { currentSource }  = this.props;
    const { selectedItem } = currentSource;
    
    const pendingItems = items.filter(i => i.status === sourceConstants.SOURCE_STATE.PENDING);
    const activeItems = items.filter(i => i.status === sourceConstants.SOURCE_STATE.ACTIVE);
    const deactivatedItems = items.filter(i => i.status === sourceConstants.SOURCE_STATE.DEACTIVATED);

    const { active, pending, inactive } = this.state;

    // item-lister with appropriate click-handler
    const mediaListerWithHandler = (items, handler) => {
      return items.map((item, id) =>
          <MediaListItem
              key={id}
              item={item}
              selectedItem={selectedItem}
              selectItem={() => handler(item)}
          />)
    };

    // pending-content structure block
    const pendingContent = (itemSelectHandler) =>
        <MediaSection square
                      defaultExpanded={true}
                      expanded={pending}
                      onChange={this.handleSectionToggle('pending', selectedItem.status)}>
          <SectionTitle expandIcon={<ExpandMoreIcon/>}>
            <div>{t("Pending Gists")}</div>
            <RefreshButton title={t("Refresh")} onClick={this.handleRefresh}>
              <SyncIcon fontSize="small" />
            </RefreshButton>
          </SectionTitle>
          {mediaListerWithHandler(pendingItems, itemSelectHandler)} {/* pass pending-list and handler for list items */}
        </MediaSection>;

    // active-content structure block
    const activeContent = (itemSelectHandler) =>
        <MediaSection square
                      defaultExpanded={true}
                      expanded={active || this.handleItemChange(selectedItem, activeItems, 'active')}
                      onChange={this.handleSectionToggle('active', selectedItem.status)}>
          <SectionTitle expandIcon={<ExpandMoreIcon/>}>{t("Active Gists")}</SectionTitle>
          {mediaListerWithHandler(activeItems, itemSelectHandler)} {/* pass active-list and handler for list items */}
        </MediaSection>;

    // deactivated-content structure block
    const deactivatedContent = (itemSelectHandler) =>
        <MediaSection square
                      expanded={inactive || this.handleItemChange(selectedItem, deactivatedItems, 'inactive')}
                      onChange={this.handleSectionToggle('inactive', selectedItem.status)}>
          <SectionTitle expandIcon={<ExpandMoreIcon/>}>{t("Inactive")}</SectionTitle>
          {mediaListerWithHandler(deactivatedItems, itemSelectHandler)} {/* pass deactivated-list and handler for list items */}
        </MediaSection>;

    return (
        <>

          <HiddenContainer mdUp implementation="css">
            <DrawerButton
                onClick={this.handleDrawerToggle}>
              {this.getFabIcon()}
            </DrawerButton>
            <SwipeableContainer
                ref={elm => this.container = elm}
                variant={'temporary'}
                ModalProps={{keepMounted: true, /* Better open performance on mobile. */ }}
                open={this.state.mobileOpen}
                onClose={this.handleDrawerToggle}
            >
              {/* if list is empty then do not show */}
              { pendingItems.length > 0     && pendingContent ( this.handleSelectItem ) }
              { activeItems.length > 0      && activeContent  ( this.handleSelectItem ) }
              { deactivatedItems.length > 0 && deactivatedContent( this.handleSelectItem ) }
            </SwipeableContainer>
          </HiddenContainer>

          <HiddenContainer smDown implementation="css">
            <Container
                ref={elm => this.container = elm}
                variant={'permanent'}
            >
              { pendingItems.length > 0     && pendingContent ( this.props.selectItem ) }
              { activeItems.length > 0      && activeContent  ( this.props.selectItem ) }
              { deactivatedItems.length > 0 && deactivatedContent( this.props.selectItem ) }
            </Container>
          </HiddenContainer>

        </>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, sources, gists, currentSource } = state;
  const { user } = authentication;
  return {
    user, sources, gists, currentSource
  };
}

function mapDispatchToProps(dispatch) {
	return {
    getSources        : ()            => dispatch( sourceActions.getSources() ),
    selectItem        : (item)        => dispatch( sourceActions.setCurrentSource(item) ),
	  mediaListExpand   : (identifier)  => dispatch({type: portfolioActionTypes.EXPAND_MEDIA_LIST, identifier}),
	  mediaListCollapse : (identifier)  => dispatch({type: portfolioActionTypes.COLLAPSE_MEDIA_LIST, identifier}),
  }
}

const connectedMedia = connect(mapStateToProps, mapDispatchToProps)(MediaList);
export { connectedMedia as MediaList };
